import InfoIcon from "@mui/icons-material/InfoOutlined";
import Stack, { type StackProps } from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";
import type { HomePageGridArea } from "../entities";

export interface GridAreaContainerProps {
  gridArea?: HomePageGridArea | undefined;
  children: ReactNode;
  title: string | ReactNode;
  tooltip?: string;
  RightSlot?: ReactNode;
  BottomRightSlot?: ReactNode;
  disableBottomSlot?: boolean;
  stackProps?: StackProps;
  className?: string;
}

export function GridAreaContainer({
  gridArea,
  RightSlot,
  BottomRightSlot,
  title,
  children,
  tooltip,
  disableBottomSlot,
  stackProps,
}: GridAreaContainerProps) {
  return (
    <Stack gridArea={gridArea} {...stackProps}>
      <Stack
        minHeight="40px"
        direction="row"
        color="text.secondary"
        mb={2}
        gap={1}
        overflow="hidden"
        justifyContent="space-between"
        alignItems="center"
      >
        {typeof title === "string" ? (
          <Typography
            variant="button"
            textOverflow="ellipsis"
            overflow="hidden"
          >
            {title}
            {tooltip && <InfoIcon fontSize="small" />}
          </Typography>
        ) : (
          title
        )}
        {RightSlot}
      </Stack>
      {children}
      {!disableBottomSlot && (
        <Stack direction="row" justifyContent="flex-end" height="40px" mt={1}>
          {BottomRightSlot}
        </Stack>
      )}
    </Stack>
  );
}
